import { Link } from 'react-router-dom';
import { Zap, ArrowRight, Terminal } from 'lucide-react';

const CTA = () => {
    return (
        <section className="py-16 sm:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden bg-[#111111] border border-white/5 p-8 sm:p-12 md:p-20 text-center">
                    {/* Glow effects */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-cyan-500/10 blur-[120px] rounded-full pointer-events-none" />
                    <div className="absolute bottom-0 right-1/4 w-[300px] h-[200px] bg-emerald-500/5 blur-[100px] rounded-full pointer-events-none" />

                    <div className="relative z-10 flex flex-col items-center">
                        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-mono mb-8 sm:mb-10 gap-2">
                            <Zap className="w-4 h-4 fill-current" />
                            Start Testing Today
                        </div>

                        <h2 className="text-3xl sm:text-4xl md:text-6xl font-extrabold text-white tracking-tight mb-6 sm:mb-8 max-w-4xl leading-[1.1]">
                            Ready to Transform Your{' '}
                            <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">Development Workflow</span>?
                        </h2>

                        <p className="text-gray-400 text-base sm:text-lg max-w-2xl mb-8 sm:mb-12 leading-relaxed">
                            Join teams already using Imago to test APIs, automate workflows, and ship faster. Get started in minutes, no credit card required.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 mb-10 sm:mb-14 w-full sm:w-auto">
                            <Link to="/organization-signup" className="w-full sm:w-auto group inline-flex items-center justify-center px-8 py-4 text-base font-bold font-mono rounded-lg text-black bg-gradient-to-r from-cyan-400 to-cyan-300 hover:from-cyan-300 hover:to-cyan-200 transition-all shadow-lg shadow-cyan-500/25 hover:shadow-cyan-500/40">
                                <Terminal className="mr-2 w-5 h-5" />
                                Organization
                                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </Link>
                            <button className="w-full sm:w-auto group inline-flex items-center justify-center px-8 py-4 border border-white/10 text-base font-bold font-mono rounded-lg text-gray-300 bg-white/5 hover:bg-white/10 hover:border-cyan-500/30 transition-all backdrop-blur-sm">
                                View Live Demo
                            </button>
                        </div>

                        <div className="flex flex-wrap justify-center gap-6 sm:gap-10">
                            {[
                                'Free sandbox to try',
                                'No credit card needed',
                                '5-minute setup'
                            ].map((text, i) => (
                                <div key={i} className="flex items-center gap-2 text-gray-500 text-xs sm:text-sm font-mono">
                                    <div className="w-2 h-2 rounded-full bg-cyan-400" />
                                    {text}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTA;
